/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  audiencePreview(payload) {
    return axios.post(`${this.url}/audience_preview`, payload);
  }

  schedule(id, payload) {
    return axios.post(`${this.url}/${id}/schedule`, payload);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  getMetrics(id) {
    return axios.get(`${this.url}/${id}/metrics`);
  }

  analyticsMetrics(id) {
    return axios.get(`${this.url}/${id}/analytics/metrics`);
  }

  analyticsContacts(id, { status, page } = {}) {
    return axios.get(`${this.url}/${id}/analytics/contacts`, {
      params: { status, page },
    });
  }
}

export default new CampaignsAPI();
